<template>
  <div>
    <ml-header :dark="true" title="编辑资料" background-color="#fff">
      <p v-if="$route.params.firstLogin" class="skip">
        <router-link :to="{ name: 'home' }">
          跳过
        </router-link>
      </p>
    </ml-header>
    <div class="user-editor-page">
      <div class="avatar" @click="handleClickUploadAvatar">
        <img :src="avatar" alt="" />
        <img src="../../assets/personal/camera@2x.png" alt="" />
        <input type="file" ref="avatarRef" @change="handleUploadAvatar" />
      </div>
      <div class="nick-name-wrapper">
        <div class="nick-name">
          <input type="text" v-model="nickname" placeholder="请输入昵称" />
        </div>
      </div>
      <div class="gender">
        <div
          class="female"
          :class="{ active: gender === female }"
          @click="gender = female"
        >
          <img src="../../assets/personal/female_icon@2x.png" alt="" />
          <p>女生</p>
        </div>
        <p>or</p>
        <div
          class="male"
          :class="{ active: gender === male }"
          @click="gender = male"
        >
          <img src="../../assets/personal/male_icon@2x.png" alt="" />
          <p>男生</p>
        </div>
      </div>
      <ml-button :is-theme-color="true" width="80%" @click="submitEditor"
        >完成</ml-button
      >
    </div>
  </div>
</template>

<script>
import { getImageFile, getImageFormData, getImageBase64 } from "@/utils/upload";
import { uploadAvatar, completeUserInfo } from "@/api/user";
import { mapActions } from "vuex";

export default {
  name: "UserEditor",
  computed: {
    nickname: {
      get() {
        return this.$store.state.user.nickname;
      },
      set(value) {
        this.$store.commit("user/SET_NICKNAME", value);
      }
    },
    gender: {
      get() {
        return this.$store.state.user.gender;
      },
      set(value) {
        this.$store.commit("user/SET_GENDER", value);
      }
    },
    avatar: {
      get() {
        return this.$store.state.user.avatar;
      },
      set(value) {
        this.$store.commit("user/SET_AVATAR", value);
      }
    }
  },
  data() {
    return {
      female: "FEMALE",
      male: "MALE",
      avatarUrl: undefined
    };
  },
  methods: {
    ...mapActions("chat", ["updateSelfInfo", "updateSelfAvatar"]),
    handleClickUploadAvatar() {
      this.$refs.avatarRef.click();
    },
    async handleUploadAvatar() {
      try {
        const element = this.$refs["avatarRef"];
        const file = getImageFile(element);
        this.avatarUrl = await uploadAvatar(file);
        this.avatar = await getImageBase64(element);
      } catch (e) {
        this.$toast("头像上传失败", 1000);
      }
    },
    async submitEditor() {
      await completeUserInfo(this.avatarUrl, this.gender, this.nickname);
      // 修改极光IM信息
      await this.updateSelfInfo(this.nickname);
      console.log("nickname修改成功");
      try {
        const file = getImageFormData(this.$refs["avatarRef"]);
        await this.updateSelfAvatar(file);
      } catch (e) {
        console.error("头像获取失败，不修改IM上的头像");
      }
      console.log("avatar修改成功");
      if (this.$route.params.firstLogin) {
        await this.$router.push({ name: "home" });
        this.$toast("用户信息完善成功", 1000);
      } else {
        await this.$router.push({ name: "personal" });
        this.$toast("用户信息修改成功", 1000);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.user-editor-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  padding-top: 57px;
  .avatar {
    position: relative;
    > img:nth-child(1) {
      border-radius: 50%;
      width: 100px;
      height: 100px;
    }
    > img:nth-child(2) {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 32px;
      height: 32px;
    }
    > input {
      display: none;
    }
  }
  .nick-name-wrapper {
    width: 100%;
    padding: 0 38px;
    height: 60px;
    .nick-name {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
      border-bottom: 1px solid rgba(242, 242, 242, 1);
      input {
        height: 22px;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        text-align: center;
      }
      input::placeholder {
        color: rgba(180, 180, 180, 1);
      }
    }
  }
  .gender {
    margin: 60px 0 90px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 114px;
      height: 40px;
      border-radius: 28px;
      transition: all 0.5s ease 0s;
      border: 1px solid rgba(153, 153, 153, 1);
      > img {
        margin: 0 4px;
        width: 16px;
        height: 20px;
      }
      > p {
        width: 32px;
        height: 21px;
        font-size: 15px;
        font-weight: 500;
        color: rgba(12, 3, 0, 1);
        line-height: 21px;
      }
    }
    > p {
      width: 15px;
      font-size: 15px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      margin: 0 16px;
    }
    .active {
      border: 1px solid rgba(253, 215, 0, 1);
      background: rgba(253, 215, 0, 1);
    }
  }
}
.skip {
  font-size: 15px;
  font-weight: 500;
  color: rgba(228, 191, 88, 1);
}
</style>
